import { useOnMount } from "./useOnMount";
export const useSetDocumentTitle = title => {
  useOnMount(() => {
    document.title = title;
  });
};